import * as React from "react"
import Layout from "../components/layout"
// Components
import Intro from "../components/Home/intro"
import FeatureSection from "../components/Home/featureSection"
import { I18nextProvider, initReactI18next } from "react-i18next"
import i18n from "i18next"
import BackgroundGraySection from "../components/core/backgroundGraySection"
import FAQ from "../components/Home/FAQ"
import MainSection from "../components/core/mainSection"
import WhyWeddingInvitation from "../components/WeddingInvitation/whyWeddingInvation"
import WeddingTemplate from "../components/WeddingInvitation/weddingTemplate"
import Feedback from "../components/Home/Feedback"
import {graphql} from 'gatsby';
import CustomerShowcase from "../components/WeddingInvitation/customerShowcase"
import DemoSection from "../components/Home/demoSection"
import WhyChooseUs from "../components/Home/whyChooseUs"

const IndexPage = () => {
	
	return <div className="h-auto w-screen landing-page-wrapper">
			<Layout>
				<MainSection>
					<Intro></Intro>
					<FeatureSection></FeatureSection>
				</MainSection>
				
				<BackgroundGraySection>
					<DemoSection props='mt-0 lg:mt-0 md:mt-0 xxs:mt-0'/>
					
					{/*<WeddingTemplate/>*/}
					{/*<CustomerShowcase props={'xxs:mt-0 mb-0 lg:mb-0 md:mb-0'}/>*/}
				</BackgroundGraySection>
				<MainSection>
					<WhyChooseUs>
					</WhyChooseUs>
				</MainSection>
				<BackgroundGraySection props='pb-0 lg:pb-0 md:pb-0 p-0 lg:p-0 md:p-0 xxs:p-5'>
					<Feedback/>
				</BackgroundGraySection>
				
				<FAQ/>
				{/*<Pricing></Pricing>*/}
				{/*<FeaturedBlog></FeaturedBlog>*/}
			</Layout>
		</div>
}

export default IndexPage

export const query = graphql`
    query($language: String!) {
        locales: allLocale(filter: {language: {eq: $language}}) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
